import { render, staticRenderFns } from "./PropertySelect.vue?vue&type=template&id=04aa9fca&"
import script from "./PropertySelect.vue?vue&type=script&lang=js&"
export * from "./PropertySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04aa9fca')) {
      api.createRecord('04aa9fca', component.options)
    } else {
      api.reload('04aa9fca', component.options)
    }
    module.hot.accept("./PropertySelect.vue?vue&type=template&id=04aa9fca&", function () {
      api.rerender('04aa9fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Editor/Properties/PropertySelect.vue"
export default component.exports